window.Environment = {
  ENVIRONMENT: process.env.ENVIRONMENT,
  BORON_URL: process.env.BORON_URL || "http://localhost:4000",
  BORON_ENTRY_URL: process.env.BORON_ENTRY_URL || "http://localhost:3100",
  LINE_OFFICIAL_ACCOUNT_ID: process.env.LINE_OFFICIAL_ACCOUNT_ID,
  SENTRY_DSN: process.env.SENTRY_DSN,
  INTERCOM_APP_ID: process.env.INTERCOM_APP_ID,
  RELEASE: process.env.RELEASE,
  GOOGLE_ANALYTICS_TRACKING_ID: process.env.GOOGLE_ANALYTICS_TRACKING_ID,
  GOOGLE_ANALYTICS_MESUREMENT_ID: process.env.GOOGLE_ANALYTICS_MESUREMENT_ID,
  MODE: process.env.NODE_ENV,
  MSW_BROWSER: process.env.MSW_BROWSER,
};
